import { postRequest, formDataRequest } from "../libs/AxiosService.util";

export async function serviceIncentiveRulesList(params) {
  return await postRequest("sales/incentive/rules", params);
}
export async function serviceIncentiveRulesUpdate(params) {
  return await postRequest("sales/incentive/rules/update", params);
}
